// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--JtbwG","prop":"_025a50318d--prop--Zc3oR"};